import { HttpClient } from 'api/http-client';
class AutomationsHttpClient extends HttpClient {
    createAutomation(automation) {
        return this.post('/automations', automation);
    }
    updateAutomation(automationId, automation) {
        return this.put(`/automations/${automationId}`, automation);
    }
    toggleAutomation(automationId, automation) {
        return this.put(`/automations/${automationId}/enable`, automation);
    }
    getAutomations() {
        return this.get('/automations');
    }
    createAutomationForReferenceId(templateId, referenceType, referenceId, automation) {
        return this.post(`/automations/template/${templateId}/${referenceType}/${referenceId}`, automation);
    }
    createGlobalAutomation(automation) {
        return this.post('/automations/global', automation);
    }
    getGlobalAutomations() {
        return this.get('/automations/global');
    }
    getGlobalAutomationsForASource(source) {
        return this.get(`/automations/source/${source}`);
    }
    getAutomationForReferenceId(templateId, referenceType, referenceId) {
        return this.get(`/automations/template/${templateId}/${referenceType}/${referenceId}`);
    }
    getAutomation(automationId) {
        return this.get(`/automations/${automationId}`);
    }
    deleteAutomation(automationId) {
        return this.delete(`/automations/${automationId}`);
    }
    getAutomationRunOrder(automationSource) {
        return this.get(`/automations/order/${automationSource}`);
    }
    reorderAutomations(automationSource, automationRunOrder) {
        return this.put(`/automations/order/${automationSource}`, automationRunOrder);
    }
}
export const AutomationsApi = new AutomationsHttpClient();
